import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class Cifrado {

    constructor() { }

    encriptar(dato) {
        var CryptoJS = require("crypto-js");
        var encripta = CryptoJS.enc.Utf8.parse(dato);
        encripta = CryptoJS.enc.Base64.stringify(encripta);
        var arr1 = [];
        for (var n = 0, l = encripta.length; n < l; n++) {
            var hex = Number(encripta.charCodeAt(n)).toString(16);
            arr1.push(hex);
        }
        return this.algoritmoBellaso(arr1.join(''));
    }


    algoritmoBellaso(texto) {
        let conversion = "";
        for (let index = 0; index < texto.length; index++) {
            const element = texto[index];
            if (element == '0') {
                conversion += 'A';
            } else if (element == '1') {
                conversion += 'B';
            } else if (element == '2') {
                conversion += 'C';
            } else if (element == '3') {
                conversion += 'D';
            } else if (element == '4') {
                conversion += 'E';
            } else if (element == '5') {
                conversion += 'F';
            } else if (element == '6') {
                conversion += 'G';
            } else if (element == '7') {
                conversion += 'H';
            } else if (element == '8') {
                conversion += 'I';
            } else if (element == '9') {
                conversion += 'L';
            } else if (element == 'a') {
                conversion += 'M';
            } else if (element == 'b') {
                conversion += 'N';
            } else if (element == 'c') {
                conversion += 'O';
            } else if (element == 'd') {
                conversion += 'P';
            } else if (element == 'e') {
                conversion += 'Q';
            } else if (element == 'f') {
                conversion += 'R';
            }
        }

        texto = conversion;

        let bellasoArray = [
            { texto: 'AB', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["N", "O", "P", "Q", "R", "S", "T", "U", "X", "Y", "Z"] },
            { texto: 'CD', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["T", "U", "X", "Y", "Z", "N", "O", "P", "Q", "R", "S"] },
            { texto: 'EF', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["Z", "N", "O", "P", "Q", "R", "S", "T", "U", "X", "Y"] },
            { texto: 'GH', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["S", "T", "U", "X", "Y", "Z", "N", "O", "P", "Q", "R"] },
            { texto: 'IL', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["Y", "Z", "N", "O", "P", "Q", "R", "S", "T", "U", "X"] },
            { texto: 'MN', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["R", "S", "T", "U", "X", "Y", "Z", "N", "O", "P", "Q"] },
            { texto: 'OP', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["X", "Y", "Z", "N", "O", "P", "Q", "R", "S", "T", "U"] },
            { texto: 'QR', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["Q", "R", "S", "T", "U", "X", "Y", "Z", "N", "O", "P"] },
            { texto: 'ST', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["P", "Q", "R", "S", "T", "U", "X", "Y", "Z", "N", "O"] },
            { texto: 'VX', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["U", "X", "Y", "Z", "N", "O", "P", "Q", "R", "S", "T"] },
            { texto: 'YZ', bellaso: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M"], resultado: ["O", "P", "Q", "R", "S", "T", "U", "X", "Y", "Z", "N"] },
        ];

        var arrayClave = [];
        var encriptacion = "";

        var valorTexto = texto;
        var valorClave = 'SENAMVO';
        valorClave = valorClave.toLocaleUpperCase();
        valorTexto = valorTexto.toLocaleUpperCase();
        var valorClaveAux = valorClave;
        //quitar los espacios
        valorTexto = valorTexto.replace(/ /g, "");

        var valorClaveLista = valorClave.split("");
        valorTexto = valorTexto.split("");
        var array = "";
        var valorClaveL = valorClaveLista.length;
        var valorTextoL = valorTexto.length;
        while (valorClaveL <= valorTextoL) {
            array = array + valorClaveAux;
            valorTextoL = valorTextoL - valorClaveL;
        }
        var sobrante = valorClaveAux.substring(0, valorTextoL);
        array = array + sobrante;
        array = array.toLocaleUpperCase();
        arrayClave = array.split("");
        //recorre la clave
        for (let i = 0; i < arrayClave.length; i++) {
            //recorre bellaso
            for (let j = 0; j < bellasoArray.length; j++) {
                //entra si solo encuentra la palabra de la clave
                if (bellasoArray[j].texto.indexOf(arrayClave[i]) != -1) {
                    //si encuentra la letra en bellaso entra al if
                    if (bellasoArray[j].bellaso.indexOf(valorTexto[i]) != -1) {
                        var posicionPalabra = bellasoArray[j].bellaso.indexOf(valorTexto[i]);
                        encriptacion = encriptacion + bellasoArray[j].resultado[posicionPalabra];
                    }
                    //si no se encuentra la letra en bellaso entra al else
                    else {
                        var posicionPalabra = bellasoArray[j].resultado.indexOf(valorTexto[i]);
                        encriptacion = encriptacion + bellasoArray[j].bellaso[posicionPalabra];
                    }
                }

            }

        }
        return encriptacion;
    }

};